// extracted by mini-css-extract-plugin
module.exports = {"photo":"team-member-avatar_photo__5xd_u"};